import { reskinStyles } from 'core/components/theme/theme-variant';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  styledText: {
    display: 'block',
    lineHeight: 1.3
  },
  verifyBtn: {
    ...reskinStyles(theme, {
      '&&': { backgroundColor: theme.colorPalette.green_100, color: theme.colorPalette.white },
      '&&:hover': { backgroundColor: theme.colorPalette.green_90, color: theme.colorPalette.white }
    }),
    height: 30,
    width: 80
  },
  UWContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignContent: 'center'
  },
  title: {
    fontSize: 16,
    color: theme.colorPalette.white
  },
  boldButton: {
    ...reskinStyles(theme, {
      '&&': { backgroundColor: theme.colorPalette.green_100, color: theme.colorPalette.white },
      '&&:hover': { backgroundColor: theme.colorPalette.green_90, color: theme.colorPalette.white }
    }),
    minWidth: 160,
    fontSize: 16,
    fontWeight: 600
  },
  bannerTitle: {
    marginBottom: theme.spacing(1),
    fontWeight: 600
  }
}));

export default useStyles;
